import { Input } from '..'

type DatePickerInputProps = {
  value?: string,
  error?: boolean,
  tabsIndex?: number,
  onClick?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void,
  onFocus?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void
}

const DatePickerInput = ({ value, error, tabsIndex, onClick, onFocus }: DatePickerInputProps) => {
  return (
    <Input
      value={value}
      placeholder="DD/MM/YYYY"
      fullWidth
      readOnly
      tabIndex={tabsIndex}
      error={error}
      onClick={(event: any) => onClick ? onClick(event) : undefined}
      onFocus={(event: any) => onClick ? onClick(event) : undefined}
    />
  )
}

export { DatePickerInput }